<template>
  <m-modal
    v-if="file"
    :value="previewModal"
    @close="$emit('close')"
  >
    <template v-slot:content>
      <v-img
        v-if="fileType === 'image'"
        :src="getFileUrl(file)"
      />
      <video
        v-if="fileType === 'video'"
        :src="getFileUrl(file)"
        controls
      />
      <audio
        v-if="fileType === 'audio'"
        :src="getFileUrl(file)"
        controls
      />
    </template>
  </m-modal>
</template>

<script>
import { getFileUrl } from "@/assets/helpers/getFileUrl";
export default {
  props: {
    file: {
      type: [Object, File, Boolean],
      required: true,
    },
    previewModal: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    fileType() {
      if (this.file.type.startsWith('image')) {
        return 'image'
      }
      if (this.file.type.startsWith('video')) {
        return 'video'
      }
      if (this.file.type.startsWith('audio')) {
        return 'audio'
      }
      return ''
    },
  },
  methods: {
    getFileUrl,
  },
}
</script>

<style>

</style>